"use client"

import type React from "react"

import { forwardRef } from "react"
import { Input } from "@/components/ui/input"

interface PhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(({ onChange, ...props }, ref) => {
  const formatPhoneNumber = (value: string) => {
    // Remove all non-digits
    const phoneNumber = value.replace(/\D/g, "")

    // Format as (XXX) XXX-XXXX
    if (phoneNumber.length <= 3) {
      return phoneNumber
    } else if (phoneNumber.length <= 6) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
    } else {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value)
    e.target.value = formatted
    if (onChange) {
      onChange(e)
    }
  }

  return <Input {...props} ref={ref} onChange={handleChange} maxLength={14} />
})

PhoneInput.displayName = "PhoneInput"

export { PhoneInput }
